module.exports = __webpack_public_path__ + "static/img/15.5bbe241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avtar/15.jpg
// module id = OPXd
// module chunks = 36